import React, { FC, ReactElement } from "react";

import { useMsal } from "@azure/msal-react";

import { Logout } from "@mui/icons-material";
import { Grid, Typography, Tooltip } from "@mui/material";
import { useIdleTimer } from "../IdleTimer";

const UserAvatar: FC<any> = (): ReactElement => {
  const { instance, accounts } = useMsal();

  const currentAccount = accounts[0]?.name;
  const email = accounts[0]?.username;

  const refreshPage = () => {
    handleLogout("redirect");
  };

  const handleLogout = (logoutType: string) => {
    if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "",
      });
    }
  };
  useIdleTimer(refreshPage, 60 * 60 * 1000);

  return (
    <Grid
      id="logout"
      container
      justifyContent="end"
      alignItems="center"
      gap={2}
      sx={{
        p: 2,
      }}
    >
      <Tooltip title={email} arrow>
        <Typography
          variant="h6"
          noWrap // prevents overflow if it's too long
          sx={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {currentAccount}
        </Typography>
      </Tooltip>
      <Tooltip title="Logout">
        <Logout
          // color="white"
          onClick={() => handleLogout("redirect")}
          sx={{
            cursor: "pointer",
            color: "white",
          }}
        />
      </Tooltip>
    </Grid>
  );
};

export default UserAvatar;
